import { FC } from "react";
import { Candidate } from "./types";
import { Position } from "./Position";
import { SearchArrowSVG } from "components/site-search/components/SearchArrowSVG";

interface Props {
  candidate: Candidate;
  isLink?: boolean;
  position?: number;
}

export const CandidateRow: FC<Props> = ({ candidate, position, isLink }) => {
  return (
    <>
      {position && <Position position={position} />}
      <div className="candidate-list__table__row__image">
        <img alt={candidate.pictureName} src={candidate.pictureUrl} />
      </div>
      <div
        className={`candidate-list__table__row__info ${isLink && "is-link"}`}
      >
        <h5>
          {candidate.firstName} {candidate.lastName}{" "}
          {isLink && (
            <span className="btn__icon">
              <SearchArrowSVG fill="#ef4135" />
            </span>
          )}
        </h5>
        <p>{candidate.bio}</p>
      </div>
    </>
  );
};
